import React from 'react';
import {NextSeo} from 'next-seo';

/* Components */
import {getLayout} from '@components/PageLayouts/Layout/Standard';
import IframeView from '@components/IframeView';

/* Exportable Iframe */
export const PrivacyIframe = () => <IframeView callerPageName="privacy-policy" src={`${process.env.NEXT_PUBLIC_WEBFLOW_CONTENTS_URL}privacy-policy`} />

function PrivacyPage(props: any) {
  return (
    <>
      <NextSeo title="Privacy Policy" />
      <PrivacyIframe />
    </>
  );
}

PrivacyPage.pageAttributes = {page: 'privacyPolicy'};
PrivacyPage.Layout = getLayout({promo: false, footer: true});

export default PrivacyPage;
